import React from 'react';
import IllustrationIconSelector from '../../../../common/src/components/IllustrationIconSelector';
import { useTranslation } from 'react-i18next';
import { RadioGroup, Text } from '@wegroup/design-system';
import IllustrationRadioButton from '../../components/input/IllustrationRadioButton';
import { setFlowType } from '../../store/redux/slices/selectionSlice';
import {
  flowIdRiskAnalysisBE,
  flowIdRiskAnalysisShortBE,
} from '../../../../flows/src/constants/flowIds';
import SelectionViewWrapper from '../../components/selection/SelectionViewWrapper';
import {
  useLouiseDispatch,
  useLouiseSelector,
} from '../../../../sales-conversation/src/store/redux/store';
import { useFlowsDispatch } from '../../../../common/src/utils/globalVariables';
import { setFlowId } from '../../../../flows/src/store/redux/slices/flowsSlice';
import { isSocialLoginUrl } from '../../../../app/src/features/authentication/constants/SocialAuth';

enum FlowTypes {
  SHORT_FLOW = 'SHORT_FLOW',
  LONG_FLOW = 'LONG_FLOW',
}

const FlowSelection: React.FC<React.PropsWithChildren<unknown>> = () => {
  const flowsDispatch = useFlowsDispatch();
  const dispatch = useLouiseDispatch();
  const selectedValue = useLouiseSelector(
    (state) => state.riskAnalysisSelection.flowType,
  );
  const { t } = useTranslation();
  const handleChange = (value: string) => {
    if (value === FlowTypes.SHORT_FLOW)
      flowsDispatch(setFlowId(flowIdRiskAnalysisShortBE));
    else flowsDispatch(setFlowId(flowIdRiskAnalysisBE));
    dispatch(setFlowType(value));
  };

  return (
    <SelectionViewWrapper
      onContinueUrl="/risk-analysis/selection/subject-selection"
      onBackUrl={isSocialLoginUrl ? '/risk-analysis' : '/conversation'}
      question={t('Choose from the options below')}
      disabled={!selectedValue}
    >
      <RadioGroup
        display="flex"
        flexWrap="wrap"
        justifyContent={{ base: 'flex-start', mobileL: 'center' }}
        gridGap="6"
        onChange={handleChange}
        value={selectedValue}
      >
        <IllustrationRadioButton
          value={FlowTypes.SHORT_FLOW}
          Illustration={
            <IllustrationIconSelector
              active={selectedValue === FlowTypes.SHORT_FLOW}
              type="offer_view"
            />
          }
          dataTestId={`RISK-ANALYSIS_FLOW-SELECTION_RADIO-${FlowTypes.SHORT_FLOW}`}
        >
          <p
            dangerouslySetInnerHTML={{
              __html: t('RISK-ANALYSIS_FLOW-SELECTION_RADIO-SHORT-FLOW'),
            }}
          />
          <Text textStyle="normalBody" mt="2">
            {t('RISK-ANALYSIS_FLOW-SELECTION_RADIO-SHORT-FLOW_DESC')}
          </Text>
        </IllustrationRadioButton>
        <IllustrationRadioButton
          value={FlowTypes.LONG_FLOW}
          Illustration={
            <IllustrationIconSelector
              active={selectedValue === FlowTypes.LONG_FLOW}
              type="personal_analysis"
            />
          }
          dataTestId={`RISK-ANALYSIS_FLOW-SELECTION_RADIO-${FlowTypes.LONG_FLOW}`}
        >
          <p
            dangerouslySetInnerHTML={{
              __html: t('RISK-ANALYSIS_FLOW-SELECTION_RADIO-LONG-FLOW'),
            }}
          />
          <Text textStyle="normalBody" mt="2">
            {t('RISK-ANALYSIS_FLOW-SELECTION_RADIO-LONG-FLOW_DESC')}
          </Text>
        </IllustrationRadioButton>
      </RadioGroup>
    </SelectionViewWrapper>
  );
};

export default FlowSelection;
